import { Component, OnInit } from '@angular/core';
import { ResetPasswordEmailDto } from '@core/interfaces/email.interface';
import { EmailService } from '@core/services/email.service';
import { FormUtils } from '@core/utils/form-utils';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@shared/services/language.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-request-reset-password',
  templateUrl: './request-reset-password.component.html',
  styleUrls: ['./request-reset-password.component.scss']
})
@UntilDestroy()
export class RequestResetPasswordComponent implements OnInit {

  resetPassword: ResetPasswordEmailDto = {
    email: '',
    languageCode: 'it',
  };
  private subscription: Subscription;
  isEmailInvalid = false;
  emailSent = false;

  constructor(
    private languageService: LanguageService,
    private emailService: EmailService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.emailService.showReCaptchaBadge();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.emailService.hideReCaptchaBadge();
  }

  onSubmit() {
    if(FormUtils.emailRegex.test(this.resetPassword.email)) {
      this.isEmailInvalid = false;
      this.resetPassword.languageCode = this.languageService.userSelectedLanguage.code;
      this.subscription = this.recaptchaV3Service.execute('resetPassword').subscribe((token: string) => {
        this.emailService.verifyReCaptcha({responseToken: token}).pipe(untilDestroyed(this)).subscribe(() => {
          this.emailService.sendResetPasswordEmail(this.resetPassword).pipe(untilDestroyed(this)).subscribe(() => {
            this.emailSent = true;
          });
        });
      });
    } else {
      this.isEmailInvalid = true;
    }
  }

}
